export default __webpack_public_path__ + "static/media/115_sharkoak.d39f29b3.webp";